import { mutatorAction } from 'satcheljs';
import { ComposeViewState } from 'owa-mail-compose-store';

export default mutatorAction(
    'SubjectPicker_showSubjectPickerButton',
    (composeViewState: ComposeViewState, showSubjectPickerButton: boolean) => {
        composeViewState.subjectPickerViewState.showSubjectPickerButton = showSubjectPickerButton;
    }
);
